import { storage } from './storage';
import { user } from './user';

export default {
  storage,
  user
};
